import { render, staticRenderFns } from "./MessageInactiveInbox.vue?vue&type=template&id=5e8b2e96"
import script from "./MessageInactiveInbox.vue?vue&type=script&lang=js"
export * from "./MessageInactiveInbox.vue?vue&type=script&lang=js"
import style0 from "./MessageInactiveInbox.vue?vue&type=style&index=0&id=5e8b2e96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports